import { AlertCircle } from 'lucide-react'
import { useTranslation } from 'react-i18next'

export function InlineError({ onRetry }: { onRetry: () => void }) {
  const { t } = useTranslation()
  return (
    <div
      style={{
        padding: '10px 14px',
        borderRadius: '8px',
        border: '1px solid var(--destructive)',
        background: 'var(--destructive-surface)',
        color: 'var(--destructive)',
        fontSize: 12,
        display: 'flex',
        alignItems: 'center',
        gap: 10,
      }}
    >
      <AlertCircle size={13} />
      <span style={{ flex: 1 }}>{t('documents.detail.failedToLoadDetail')}</span>
      <button
        type="button"
        onClick={onRetry}
        style={{
          background: 'transparent',
          border: 'none',
          color: 'var(--destructive)',
          fontFamily: 'inherit',
          fontSize: 12,
          fontWeight: 600,
          cursor: 'pointer',
          textDecoration: 'underline',
        }}
      >
        {t('documents.detail.retry')}
      </button>
    </div>
  )
}
